import { ContactAnalysisStateConclusion, ContactAnalysisStateConclusionTypeEnum } from '../../api/generated';

export function getCompanyMatchStateFromContactAnalysisConclusions(conclusions: ContactAnalysisStateConclusion[]) {
  return {
    noMatch: conclusions.find(c => c.type === ContactAnalysisStateConclusionTypeEnum.ContactCouldNotBeMatchedToCompany),
    satisfactoryMatch: conclusions.find(c => c.type === ContactAnalysisStateConclusionTypeEnum.ContactExplicitMatchToCompany) || conclusions.find(c => c.type === ContactAnalysisStateConclusionTypeEnum.ContactStrongMatchToCompany),
    uncertainMatches: conclusions.filter(c => c.type === ContactAnalysisStateConclusionTypeEnum.ContactWeakMatchToCompany)
  };
}
